import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Icon$6 from './Images/Visa.js';
import Icon$5 from './Images/MasterCard.js';
import Icon$1 from './Images/Jcb.js';
import Icon$3 from './Images/Discover.js';
import Icon$4 from './Images/Amex.js';
import Icon from './Images/Cc.js';
import Icon$2 from './Images/Diners.js';
import styles from './CardBrandImage.module.scss.js';

var _excluded = ["brand", "style"];

function CardBrandImage(_ref) {
  var _ref$brand = _ref.brand,
      brand = _ref$brand === void 0 ? '' : _ref$brand,
      style = _ref.style,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var BrandImage;

  switch (brand.toLowerCase()) {
    case 'visa':
      BrandImage = /*#__PURE__*/React.createElement(Icon$6, null);
      break;

    case 'mastercard':
      BrandImage = /*#__PURE__*/React.createElement(Icon$5, null);
      break;

    case 'amex':
      BrandImage = /*#__PURE__*/React.createElement(Icon$4, null);
      break;

    case 'discover':
      BrandImage = /*#__PURE__*/React.createElement(Icon$3, null);
      break;

    case 'diners':
      BrandImage = /*#__PURE__*/React.createElement(Icon$2, null);
      break;

    case 'jcb':
      BrandImage = /*#__PURE__*/React.createElement(Icon$1, null);
      break;

    default:
      BrandImage = /*#__PURE__*/React.createElement(Icon, null);
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    key: brand,
    style: style,
    className: styles.wrapper
  }, props), BrandImage);
}

CardBrandImage.propTypes = {
  brand: PropTypes.oneOf(['default', 'visa', 'mastercard', 'amex', 'discover', 'diners', 'jcb']),
  style: PropTypes.object
};

export { CardBrandImage as default };
//# sourceMappingURL=index.js.map
